import React, { JSX, useEffect, useRef } from 'react';
import {
    ImageField,
    TextField,
    RichTextField,
    Link,
    LinkField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { observeInView } from 'src/hooks/observeInView';

type LinkBarProps = StyleguideComponentProps & {
    fields: {
        MarginSize: {
            fields: {
                heading: {
                    value: string;
                };
            };
        };
        logo?: ImageField;
        linkText?: TextField;
        title?: TextField;
        description?: RichTextField;
        backgroundcolor?: {
            id: string;
            url: string;
            name: string;
            displayName: string;
            fields: {
                heading: TextField;
            };
        };
        linkbarchilditems?: Array<{
            id: string;
            url: string;
            name: string;
            displayName: string;
            fields: {
                MarginSize: {
                    fields: {
                        heading: {
                            value: string;
                        };
                    };
                };
                link: LinkField;
            };
        }>;
        children?: Array<{
            id: string;
            url: string;
            name: string;
            displayName: string;
            fields: {
                link: LinkField;
            };
        }>;
    };
};

const LinkBar = (props: LinkBarProps): JSX.Element => {
    if (!props || !props.fields) {
        return <div></div>;
    }
    const marginSize = getMarginSize(
        props?.fields?.MarginSize?.fields?.heading?.value
    );
    const { title, description, backgroundcolor, linkbarchilditems } =
        props.fields;

    const links = linkbarchilditems || [];
    const animRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!animRef.current) return;
        observeInView(animRef.current);
    }, []);

    return (
        <div
            className={classNames('link-bar', marginSize)}
            id={`link-bar-${props.rendering?.uid}`}
        >
            <div className="link-bar__content">
                <div className="link-bar__header">
                    {title && <h2 className="link-bar__title">{title.value}</h2>}
                    {description && (
                        <div className="link-bar__description">
                            <p>{description.value}</p>
                        </div>
                    )}
                </div>
                <div
                    className="link-bar__link-area"
                    data-background={backgroundcolor?.name || 'Dark'}
                >
                    <div className="links list-fade-in-anim animated" ref={animRef}>
                        {links &&
                            links.map(link => (
                                <div
                                    key={link.id}
                                    className={classNames(
                                        'link-bar__link-item',
                                        getMarginSize(
                                            link?.fields?.MarginSize?.fields?.heading?.value
                                        )
                                    )}
                                >
                                    <div className="link-bar__link-container">
                                        <Link
                                            field={link.fields.link}
                                            className="link-bar__link-text link-button"
                                        >
                                            {link.displayName}
                                        </Link>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinkBar;